import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Copy, Row, Optional } from '@honda-canada/design-system-react';
import themeStyles from './styles/Response.styles';
import ResponseMessage from '../ResponseMessage';
import useResponseMessageData from '../../hooks/useResponseMessageData';
import ResponsePropTypes from './IResponseProps';
import useConfiguration from '../../hooks/useConfiguration';

const ShowResult = themeStyles.apply(Copy, 'ShowResult');

const Response = ({ vinData, userVin, brandMatchesSite, isVinValid }) => {
  const { showResultFontStyle } = useConfiguration();
  const { t } = useTranslation();
  const {
    productLine,
    productLink,
    messageText,
    hasCompletedCampaigns,
    hasOutstandingCampaigns,
    shouldShowMsg,
    isCrossBrandMsg,
  } = useResponseMessageData(vinData, userVin, isVinValid, brandMatchesSite);

  const vinSearchResult = (
    <ShowResult data-testid="cy-result-vin" showResultFontStyle={showResultFontStyle}>
      {t('Sub-apps.Recalls.showingResultsForVinLabel', { vinNumber: userVin })}
    </ShowResult>
  );

  return (
    <Box mt={6}>
      <Row flexDirection="column" alignItems="center" alignContent="center">
        <Box>{vinSearchResult}</Box>
        <Optional when={shouldShowMsg}>
          <ResponseMessage
            messageText={messageText}
            productLine={productLine}
            productLink={productLink}
            hasOutstandingCampaigns={hasOutstandingCampaigns}
            hasCompletedCampaigns={hasCompletedCampaigns}
            isCrossBrandMsg={isCrossBrandMsg}
            isVinValid={isVinValid}
          />
        </Optional>
      </Row>
    </Box>
  );
};

Response.propTypes = ResponsePropTypes;

export default Response;
